// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AvailablePackagesController from "./available_packages_controller"
application.register("available-packages", AvailablePackagesController)

import PackagePickerController from "./package_picker_controller"
application.register("package-picker", PackagePickerController)

import ExpiredLiffAppController from "./expired_liff_app_controller"
application.register("expired-liff-app", ExpiredLiffAppController)

import DismissCardController from "./dismiss_card_controller"
application.register("dismiss-card", DismissCardController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import OrderSummaryController from "./order_summary_controller"
application.register("order-summary", OrderSummaryController)

import SlipUploadController from "./slip_upload_controller"
application.register("slip-upload", SlipUploadController)


import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HoroDailyController from "./horo_daily_controller"
application.register("horo-daily", HoroDailyController)

import ShareDailyController from "./share_daily_controller"
application.register("share-daily", ShareDailyController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import UsageUpdateModalController from "./usage_update_modal_controller"
application.register("usage-update-modal", UsageUpdateModalController)

import AdminBundleItemController from "./admin/bundle_item.js"
application.register("admin--bundle-item", AdminBundleItemController)

import AdminBundleListController from "./admin/bundle_list.js"
application.register("admin--bundle-list", AdminBundleListController)

import AdminBundlePackageController from "./admin/bundle_package.js"
application.register("admin--bundle-package", AdminBundlePackageController)

import AdminMiniContentListController from "./admin/mini_content_list.js"
application.register("admin--mini-content-list", AdminMiniContentListController)

import AdminOrderListController from "./admin/order_list.js"
application.register("admin--order-list", AdminOrderListController)

import AdminTopupPackageController from "./admin/topup_package.js"
application.register("admin--topup-package", AdminTopupPackageController)

import AdminPackageFormController from "./admin/package_form.js"
application.register("admin--package-form", AdminPackageFormController)

import AdminSubCardController from "./admin/sub_card.js"
application.register("admin--sub-card", AdminSubCardController)

import MonthlyUnlockController from "./monthly_unlock_controller"
application.register("monthly-unlock", MonthlyUnlockController)

import OnboardingTourController from "./onboarding_tour_controller"
application.register("onboarding-tour", OnboardingTourController)

import AdminMultiSelectTagsController from "./admin/multi_select_tags_controller"
application.register("admin--multi-select-tags", AdminMultiSelectTagsController)

import TopicChipsController from "./topic_chips_controller"
application.register("topic-chips", TopicChipsController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CardPickController from "./card_pick_controller"
application.register("card-pick", CardPickController)

import OracleChatController from "./oracle_chat_controller"
application.register("oracle-chat", OracleChatController)

import LineShareController from "./line_share_controller"
application.register("line-share", LineShareController)

import TransitWheelController from "./transit_wheel_controller"
application.register("transit-wheel", TransitWheelController)

import AdminLauncherController from "./admin_launcher_controller"
application.register("admin-launcher", AdminLauncherController)
